import { TAppState } from '../../types/appState';
import { EMasterTabs } from '../../types/masterFilters';

export const isShowSubAgentChatListSelector = (state: TAppState) => {
  const { selectedSubAgentId, activeTab } = state.masterFilters;

  return Boolean(activeTab === EMasterTabs.SubAgentsChats && selectedSubAgentId);
};
